export enum EnumStatusProdutoPedido {
    DISPONIVEL = 1,
    INDISPONIVEL = 2,
    DESISTENCIA = 3,
    TROCADO = 4,
}